import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const BasecallingPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const targetId = location.hash.replace("#", "");
    const target = document.getElementById(targetId);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  }, [location.hash]);

  return (
    <section className="subpage-section">
      <div className="container">
        <h1 className="subpage-title">Basecalling</h1>
        <p className="subpage-body">
          FeraBio provides cloud basecalling for both standard DNA workflows and
          advanced XNA/modified workflows, eliminating local hardware
          bottlenecks.
        </p>
        <div className="subpage-visual">
          <div className="subpage-visual-media">
            Placeholder image: raw signal input to basecalled output comparison
          </div>
          <div className="subpage-visual-notes">
            <h2>What is most useful on this page</h2>
            <ul>
              <li>
                Side-by-side view of raw signal versus basecalled sequence.
              </li>
              <li>
                Model-selection screenshot with standard and advanced options.
              </li>
              <li>Throughput summary visual to show cloud scaling value.</li>
            </ul>
          </div>
        </div>
        <div className="subpage-feature-grid">
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: standard DNA run settings panel
            </div>
            <h3>Standard DNA Basecalling</h3>
            <p>
              Run production DNA basecalling in the cloud without buying or
              managing dedicated local GPU infrastructure.
            </p>
            <Link to="/resources#quickstart" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: XNA/modified model selector
            </div>
            <h3 id="xna-models">XNA and Modified Basecalling</h3>
            <p>
              Access exclusive model options for XNA and modified/epigenetic
              sequences where standard tools are often insufficient.
            </p>
            <Link to="/resources#guides" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: multi-run cloud scaling dashboard
            </div>
            <h3>Cloud-first Scalability</h3>
            <p>
              Scale both broad user workloads and niche advanced workloads from
              one platform with consistent outputs and controls.
            </p>
            <Link to="/waitlist" className="read-more-link">
              Request access
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BasecallingPage;
